import { useState, useMemo } from 'react'
import type { ProjectFilters } from '@/types'

export const ALL_CLIENTS = '__all__'

export interface Filters {
  search: string
  type: string
  industry: string
  client: string
}

const defaultFilters: Filters = {
  search: '',
  type: 'all',
  industry: 'all',
  client: ALL_CLIENTS,
}

export function useProjectFilters() {
  const [filters, setFilters] = useState(defaultFilters)
  const [viewMode, setViewMode] = useState<'list' | 'tile'>('list')

  const setFilter = (key: keyof Filters, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value }))
  }

  const apiFilters: ProjectFilters = useMemo(() => ({
    search: filters.search || undefined,
    industry: filters.industry !== 'all' ? filters.industry : undefined,
    type: filters.type !== 'all' ? filters.type : undefined,
    client: filters.client !== ALL_CLIENTS ? filters.client : undefined,
  }), [filters])

  return { filters, setFilter, viewMode, setViewMode, apiFilters }
}
